/**
 * Application entry point
 */

// Load application styles
import 'index.scss';

// ================================
// START YOUR APP HERE
// ================================
import router from './router';

// TODO: refactor to el
const app = new Vue({
  el: '#layout',
  router,
});

// components
import './components/pagination';
import './components/alphabet';
import './components/listing';
